import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getBooking, cleanBooking } from "store/bookings"
import { cleanTrip, receivedTrip } from "store/trips"
import { TripsPreview } from "components/trips/TripsPreview"
import Spinner from "components/common/Spinner"
import { useTitle } from "hooks/useTitle"
import GuestHeader from "layoutsV2/client/GuestHeader"

const ClientGuestBookingConfirmation = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const { booking } = useSelector((store) => store.bookings)
  const { trip, loading } = booking
  const isLoggedIn = !!localStorage.getItem('access_token')
  useTitle(trip?.title)

  useEffect(() => {
    dispatch(getBooking(params.id))
      .then(({ trip }) => dispatch(receivedTrip(trip)))
    return () => dispatch(cleanBooking()) && dispatch(cleanTrip())
  }, [params.id]) //eslint-disable-line

  if (loading) return <Spinner />

  return (
    <main className="vstack min-vh-100 bg-light">
      <GuestHeader hideUserControls={!isLoggedIn} />
      <div className="flex-fill vstack min-h-100 py-15 px-80">
        {booking.id && <TripsPreview />}
      </div>
    </main>
  )
}

export default ClientGuestBookingConfirmation
